<template>
  <div>
    <BOrchestrator />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {BOrchestrator} from 'bootstrap-vue-next';

export default {
  name: 'app',
  components: {
    BOrchestrator
  },
  computed: {
    ...mapGetters('app', ['isDarkMode']),
  },
  watch: {
    isDarkMode() {
      this.updateDxTheme();
    }
  },
  methods: {
    ...mapActions('app', ['initializeTheme']),
    updateDxTheme() {
      const theme = this.isDarkMode ? 'dx.dark.css' : 'dx.light.css';
      const linkId = 'dx-theme-stylesheet';
      let link = document.getElementById(linkId);
      if (!link) {
        link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }

      // Use BASE_URL to ensure correct path in production/subfolders
      link.href = `${process.env.BASE_URL}static/css/${theme}`;
    }
  },
  mounted() {
    // Theme beim Start der App initialisieren
    this.initializeTheme();
    this.updateDxTheme();
  }
}
</script>

<style lang="scss" >
  @import '~animate.css/animate.min.css';
  @import '~flag-icon-css/css/flag-icon.css';
  @import '~devextreme/dist/css/dx.common.css';
  /* @import '~vue2-daterange-picker/dist/vue2-daterange-picker.css'; */
  /* @import '~vue3-daterange-picker/dist/vue3-daterange-picker.css'; */

</style>
